import PageGroupComponent from '../components/PageGroup/PageGroup/viewer/PageGroup';


const PageGroup = {
  component: PageGroupComponent
};


export const components = {
  ['PageGroup']: PageGroup
};

